module.exports = __webpack_public_path__ + "static/media/sanguo-5.a4aba972.png";